import { render, staticRenderFns } from "./myTeam.vue?vue&type=template&id=134d7a8c&scoped=true"
import script from "./myTeam.vue?vue&type=script&lang=js"
export * from "./myTeam.vue?vue&type=script&lang=js"
import style0 from "./myTeam.vue?vue&type=style&index=0&id=134d7a8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134d7a8c",
  null
  
)

export default component.exports